/**
 * Les icônes qu'une fiche de dashboard sur mesure peut porter.
 *
 * ⚠️ **Une table, et la liste en dérive.** `DashboardSurMesure.icone` stocke un **nom**
 * (`'Building2'`), pas un emoji : l'afficher tel quel écrit « Building2 » en toutes lettres
 * dans la carte — ce que l'accueil faisait. Il faut donc résoudre le nom en composant, et une
 * liste de noms sans table de résolution ne suffit pas.
 *
 * ⚠️ **Nommément importées, jamais `import * as`.** Lucide porte plusieurs milliers d'icônes,
 * et l'import étoilé désarme l'élagage du bundle : il les embarquerait toutes, pour douze
 * employées. Le bundle de cette application pèse déjà 1,3 Mo.
 *
 * ⚠️ **Le repli n'est pas facultatif.** Une fiche peut porter un nom retiré de cette table —
 * par une ancienne version, ou par une fiche créée depuis le MCP. Rendre `undefined` comme
 * composant fait échouer le rendu de toute la section ; `LayoutDashboard` ne coûte rien.
 */

import {
  LayoutDashboard, BarChart3, LineChart, PieChart, Activity, Users,
  MousePointerClick, Search, FileText, Building2, Gauge, Target
} from 'lucide-react';

const ICONES_DASHBOARD = {
  LayoutDashboard, BarChart3, LineChart, PieChart, Activity, Users,
  MousePointerClick, Search, FileText, Building2, Gauge, Target
};

/** Les noms proposés à la création d'une fiche — dérivés de la table, jamais recopiés. */
export const NOMS_ICONES_DASHBOARD = Object.keys(ICONES_DASHBOARD);

/** Le composant d'une icône, ou le dashboard générique si le nom est inconnu. */
export const iconeDashboard = (nom) => ICONES_DASHBOARD[nom] || LayoutDashboard;

export default ICONES_DASHBOARD;
